import { defineComponent, h } from 'vue'
import qs from 'qs'
import { createRouter, createMemoryHistory } from 'vue-router'
const router = createRouter({
  // Use createMemoryHistory for a non-URL-based (abstract) history
  history: createMemoryHistory(),
  parseQuery: qs.parse,
  stringifyQuery: qs.stringify,
  routes: [
    {
      path: '',
      name: 'empty-route',
      component: defineComponent({
        name: 'EmptyRoute',
        render() {
          return h('div')
        }
      })
    }
  ]
})

export default router
